import type { pilots as en } from '@/i18n/locales/en/pilots';
import type { Translation } from '@/i18n/types';

export const pilots: Translation<typeof en> = {
  page: {
    title: 'Pilotlar',
    lead: "{{company}}'de yürütülen pilotlar.",
    noScope: 'Pilotlarını görmek için bir şirket seçin.',
    listTitle: 'Pilotlar',
    empty: 'Henüz pilot yok.',
  },
  status: {
    draft: 'Taslak',
    baseline: 'Başlangıç ölçümü',
    active: 'Aktif',
    interim_review: 'Ara değerlendirme',
    final_review: 'Son değerlendirme',
    completed: 'Tamamlandı',
    scaled: 'Yaygınlaştırıldı',
  },
  phases: {
    baseline: 'Başlangıç ölçümü',
    interim: 'Ara değerlendirme',
    final: 'Son değerlendirme',
  },
  kpis: {
    participationRate: 'Katılım oranı',
    activeUsers: 'Aktif kullanıcılar',
    dailyUsage: 'Günlük kullanım',
    satisfaction: 'Çalışan memnuniyeti',
    avgVitality: 'Ort. canlılık',
    aiCoachUsage: 'AI koç kullanımı',
    challengeUsage: 'Challenge kullanımı',
    rolloutReadiness: 'Yaygınlaştırma önerisi',
  },
  form: {
    title: 'Yeni pilot',
    name: 'Ad',
    startDate: 'Başlangıç tarihi',
    departments: 'Departmanlar',
    submit: 'Pilot oluştur',
  },
  detail: {
    title: 'Pilot',
    lead: "KPI'lar, trendler, sonuçlar ve gerekçeli bir yaygınlaştırma kararıyla canlılık pilotunun değerlendirmesi.",
    exportPdf: 'Raporu dışa aktar (PDF)',
    hero: {
      badge: {
        success: 'Pilot başarılı oldu',
        partial: 'Pilot devam ediyor',
        atRisk: 'Dikkat gerekiyor',
        pending: 'Pilot yürütülüyor',
      },
      goals: {
        success: 'Tüm KPI hedeflerine ulaşıldı',
        partial: 'Bazı KPI hedeflerine ulaşıldı',
        atRisk: 'KPI hedeflerine henüz ulaşılmadı',
        pending: 'Öneri için henüz yeterli veri yok',
      },
      headlinePrefix: {
        success:
          "Pilot, NOLATR Fit'in canlılığı ölçülebilir şekilde artırdığını kanıtlıyor — öneri:",
        partial: 'Pilot iyileşme gösteriyor — öneri:',
        atRisk: 'Pilot henüz ölçülebilir bir iyileşme göstermiyor — öneri:',
        pending: 'Henüz öneri için yeterli veri yok:',
      },
      headlineAdvice: {
        success: 'tüm organizasyona yaygınlaştırın.',
        partial: 'daha fazla veri için pilotu uzatın.',
        atRisk: 'yaygınlaştırmadan önce bunu düzeltin.',
        pending: 'yaygınlaştırma.',
      },
    },
    summary: {
      participation: 'Katılım',
      dailyActive: 'Günlük aktif',
      stress: 'Stres',
      sleep: 'Uyku',
      goal: 'hedef %{{value}}',
      vsBaseline: 'başlangıca göre',
      minutes: '{{value}} dk',
    },
    aiSummaryTitle: 'AI özeti',
    recommendationEmpty: 'Henüz özet yazılmadı.',
    kpisTitle: "KPI'lar",
    chartTitle: 'Pilot sırasında canlılık ve aktivite',
    chartCurrent: 'Güncel',
    noData: 'Henüz veri yok.',
    participantCount: '{{count}} katılımcı',
    evaluationsTitle: 'Sonuçlar & öneriler',
    conclusionsTitle: 'Sonuçlar',
    recommendationsListTitle: 'Öneriler',
    evaluationsEmpty: 'Henüz değerlendirme kaydedilmedi.',
    evaluationPhase: 'Aşama',
    evaluationConclusions: 'Sonuçlar',
    evaluationRecommendations: 'Öneriler',
    decisionTitle: 'Karar',
    scaleRequiresCompleted:
      'Yaygınlaştırma yalnızca son değerlendirme tamamlandıktan sonra mümkündür.',
  },
  actions: {
    new: 'Yeni pilot',
    cancel: 'İptal',
    save: 'Kaydet',
    edit: 'Düzenle',
    addEvaluation: 'Değerlendirme ekle',
    extend: 'Uzat',
    scale: 'Yaygınlaştır',
  },
};
